import PropTypes from 'prop-types';
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getCloseReadingProgressText, getCloseReadingProgressRatio } from 'a/hub/selectors/studentProgressSelectors';
import { useFirstUserInteraction } from 'lib/hooks';
import { advanceToNextWorkshopStep } from 'root/activities/hub/actions/workshopActions';
import { BaseSuccessModal, FractionText, PortalIcon } from '../sharedComponents';

const TFESuccessModal = ({ closeModal, config }) => {
  const dispatch = useDispatch();

  const fractionText = useSelector(getCloseReadingProgressText);
  const completeRatio = useSelector(getCloseReadingProgressRatio);

  const {
    heading = 'Mission Complete!',
    text = 'You have unlocked the next *eReader* activity, and earned a *reward*!',
  } = config;

  const firstUserInteraction = useFirstUserInteraction();

  const onClick = (e) => {
    const source = 'TFESuccessModal';
    dispatch(advanceToNextWorkshopStep(source, true, config.openedAtStep));
    firstUserInteraction(e);
    closeModal(e);
  };

  return (
    <BaseSuccessModal headerText={heading} descriptionText={text} onConfirm={onClick} actionScope="tfe-success-modal">
      <PortalIcon top={198} left={323} completeRatio={completeRatio} />
      <FractionText top={333} left={361}>
        {fractionText}
      </FractionText>
    </BaseSuccessModal>
  );
};

TFESuccessModal.propTypes = {
  config: PropTypes.object.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default TFESuccessModal;
